import React from 'react';

import Header from '../components/Header';
import Footer from '../components/Footer';
import SuggestResult from '../components/Suggest/Result';

const Layout = ({ children }) => (
  <>
    <Header />
    <div className="container">{children}</div>
    <Footer />
    <SuggestResult />
  </>
);

export default Layout;
